import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VaccinationMasterRoutingModule } from './vaccination-master-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from 'angular-datatables';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { BsDatepickerModule, TimepickerModule } from 'ngx-bootstrap';
import { AppMaterialModule } from 'src/app/app-material.module';
import { AnimalCreationComponent } from './animal-creation/animal-creation.component';
import { VaccineCreationComponent } from './vaccine-creation/vaccine-creation.component';
import { VaccineScheduleComponent } from './vaccine-schedule/vaccine-schedule.component';
import { VaccineConfigurationComponent } from './vaccine-configuration/vaccine-configuration.component';


@NgModule({
  declarations: [
    AnimalCreationComponent,
    VaccineCreationComponent,
    VaccineScheduleComponent,
    VaccineConfigurationComponent
  ],
  imports: [
    CommonModule,
    VaccinationMasterRoutingModule,
    ReactiveFormsModule,
    DataTablesModule,
    FormsModule,
    NgbModule,
    BsDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule,
    TimepickerModule.forRoot(),
    AppMaterialModule
  ]
})
export class VaccinationMasterModule { }
